import { lazy } from "react"
import { Navigate } from "react-router-dom"

const Permission = lazy(() => import("../../pages/Permission"))
const PermissionDetail = lazy(() => import("../../pages/Permission/PermissionDetail"))
const Surveillance = lazy(() => import("../../pages/Surveillance"))
const SurveillanceEpisodeDetail = lazy(() => import("../../pages/Surveillance/EpisodeDetail"))
const SurveillanceCaseDetail = lazy(() => import("../../pages/Surveillance/CaseDetail"))
const SurveillanceSignalDetail = lazy(() => import("../../pages/Surveillance/SignalDetail"))
const UserGuide = lazy(() => import("../../pages/Guide"))

function HomeRedirect() {
  return <Navigate to="/surveillance/dashboard" replace />
}

function pageList() {
  return [
    {
      Element: HomeRedirect,
      path: "/dashboard",
      code: "HOME_CONTROLLER"
    },
    {
      Element: Permission,
      path: "/staff/:tab",
      code: "STAFF_CONTROLLER"
    },
    {
      Element: PermissionDetail,
      path: "/staff/groups/:id/:name",
      code: "STAFF_CONTROLLER"
    },
    {
      Element: Surveillance,
      path: "/surveillance/:tab",
      code: "SURVEILLANCE_CONTROLLER"
    },
    {
      Element: SurveillanceEpisodeDetail,
      path: "/surveillance/episodes/:episodeId",
      code: "SURVEILLANCE_CONTROLLER"
    },
    {
      Element: SurveillanceSignalDetail,
      path: "/surveillance/signals/:signalId",
      code: "SURVEILLANCE_CONTROLLER"
    },
    {
      Element: SurveillanceCaseDetail,
      path: "/surveillance/cases/:caseId",
      code: "SURVEILLANCE_CONTROLLER"
    },
    {
      Element: UserGuide,
      path: "/guide",
      code: "GUIDE_CONTROLLER"
    }
  ]
}

export default pageList
